import React, { useEffect, useState } from 'react';
import request from '@/utils/request';
import UserChangePassword from '@/components/user/UserChangePassword';
function UserSettingCenter() {
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    request.get('system-user-q-002').then((res) => {
      if (res.code > 0) {
        setUserInfo(res.data);
      }
    });
  }, []);

  return <UserChangePassword userInfo={userInfo} />;
}

export default UserSettingCenter;
